const TOKEN_KEY = 'expai_access_token';
const EXPIRES_KEY = 'expai_token_expires_at';
const ACTIVE_TENANT_KEY = 'expai_active_tenant';

/** The active tenant id, sent as the default X-Tenant-Id on API requests. */
export function getActiveTenantId(): string | null {
  return localStorage.getItem(ACTIVE_TENANT_KEY);
}

export function setActiveTenantId(tenantId: string | null): void {
  if (tenantId) localStorage.setItem(ACTIVE_TENANT_KEY, tenantId);
  else localStorage.removeItem(ACTIVE_TENANT_KEY);
}

export function getAccessToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getTokenExpiresAt(): string | null {
  return localStorage.getItem(EXPIRES_KEY);
}

export function setAccessToken(token: string | null, expiresAt?: string | null): void {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    if (expiresAt) localStorage.setItem(EXPIRES_KEY, expiresAt);
    else localStorage.removeItem(EXPIRES_KEY);
  } else {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EXPIRES_KEY);
  }
}

/** True if token expires within the next `skewMs` (default 5 min). */
export function isTokenExpiringSoon(skewMs = 5 * 60 * 1000): boolean {
  const exp = getTokenExpiresAt();
  if (!exp) return false;
  const t = Date.parse(exp);
  if (Number.isNaN(t)) return false;
  return t - Date.now() < skewMs;
}
